// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--TIi0B";
export var contact__container = "contact-module--contact__container--E3d1f";
export var contact__container__left = "contact-module--contact__container__left--vdOl-";
export var contact__container__left__icons = "contact-module--contact__container__left__icons--7mskg";
export var contact__container__left__text = "contact-module--contact__container__left__text--VtTgX";
export var contact__container__right = "contact-module--contact__container__right--0ifnI";
export var contact__container__right__terms = "contact-module--contact__container__right__terms--Zxga+";